// extracted by mini-css-extract-plugin
export default {"reasonField":"style_reasonField__EmgNN"};